import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { MiButton, MiDetailPageHeader, MiTab } from "@miplatform/components";
import {
  BUTTON_VARIANTS,
  ENTITY_NAMES,
  PERMISSIONS,
} from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { mdiChevronLeft, mdiPlus } from "@mdi/js";
import { usePermissions } from "@mibuildweb/hooks";
import { MilestonesTab } from "./MilestonesTab";
import { useBuildTemplateDetailsViewModel } from "./useBuildTemplateDetailsViewModel";

const BUILD_TEMPLATE_TABS = {
  MILESTONES: "milestones",
};

const BUILD_TEMPLATE_TABS_LIST = [
  {
    value: BUILD_TEMPLATE_TABS.MILESTONES,
    label: "Milestones",
  },
];

export function BuildTemplateDetails() {
  const router = useRouter();
  const { hasPermission } = usePermissions();

  const { id, activeTab } = router.params;
  const { buildTemplate, getBuildTemplate } = useBuildTemplateDetailsViewModel({
    buildTemplateId: id,
  });
  const [openAddModal, setOpenAddModal] = useState(false);
  const canCreateMilestone = hasPermission(PERMISSIONS.BUILD_TEMPLATE.UPDATE);

  const { classes } = useStyles();

  const handleTabChange = (tab) => {
    router.navigate(`/settings/milestone-management/build-types/${id}/${tab}`);
  };

  useEffect(() => {
    getBuildTemplate();
  }, []);

  return (
    <div className={classes.contentContainer}>
      <MiDetailPageHeader
        title={`${ENTITY_NAMES.BUILD_TEMPLATE}: ${buildTemplate?.name || ""}`}
        loading={!buildTemplate}
        titleIcon={mdiChevronLeft}
        actionComponent={
          activeTab === BUILD_TEMPLATE_TABS.MILESTONES && canCreateMilestone ? (
            <MiButton
              title="Edit Milestones"
              variant={BUTTON_VARIANTS.CONTAINED}
              startIcon={{
                path: mdiPlus,
                iconSize: 0.8,
              }}
              data-testid="add-task-template-btn"
              onClick={() => setOpenAddModal(true)}
            />
          ) : null
        }
      />
      <MiTab
        tabs={BUILD_TEMPLATE_TABS_LIST}
        currentTab={activeTab}
        onTabChange={handleTabChange}
      />
      {activeTab === BUILD_TEMPLATE_TABS.MILESTONES && (
        <MilestonesTab
          buildTemplate={buildTemplate}
          openAddModal={openAddModal}
          setOpenAddModal={setOpenAddModal}
          onRefresh={getBuildTemplate}
        />
      )}
    </div>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    height: "inherit",
    overflowY: "scroll",
    margin: 5,
    borderRadius: 10,
    padding: 20,
    backgroundColor: theme.palette.common.white,
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "inherit",
  },
}));
